import React from 'react';
import { Outlet } from "react-router-dom";
import { MyNavbar } from '../components/Layout/MyNavbar';
import { MyFooter } from '../components/Layout/MyFooter';
import 'bootstrap/dist/css/bootstrap.min.css';



const Layout = () => {
  return (
    <>
      <MyNavbar/>
      <Outlet />
      <MyFooter/>
    </>
  )
};

export default Layout;